<div *ngIf="document" class="documentary-list__item">
    <div class="documentary-list__item--top">
        <div>
            <h3 class="documentary-list__item-title">
                {{ document.correctLibelle }}
            </h3>
            <div *ngIf="examDetails" class="documentary-list__item--detailexam">
                <a data-tag-commander="" [appTagCommander]="'tagCo.documentselection.documentlist.examdetails.button'" (click)="toggleExamDetails()">
                    {{ 'documentselection.documentlist.link.details' | i18n }}
                </a>
            </div>
            <p
                *ngIf="documentStatus"
                class="documentary-list__item-status"
                [ngClass]="{
                    'documentary-list__item-status--sent': filesConforme(document) || filesProvided(document) || document.transmis,
                    'documentary-list__item-status--provide': filesWaiting(document) && !document.transmis,
                    'documentary-list__item-status--error': filesInError(document) || filesNonConforme(document)
                }"
            >
                {{ documentStatus | i18n }}
            </p>
        </div>
        <div *ngIf="withAppointment" class="documentary-list__item--top__right">
            {{ 'documentselection.documentlist.infoappointment' | i18n }}&nbsp;
            <img class="documentary-list__item--top__right__arm-image" data-cand-image="assets/images/logo-ARM.svg" [appAssetSrc]="'assets/images/logo-ARM.svg'" alt="arm-logo" />
        </div>
    </div>
    <div class="documentary-list__item--bottom">
        <ng-container *ngIf="!withAppointment">
            <div data-ng-if="!appointmentMade || bloodOrBioCofrac(doc.typology)" class="documentary-list__item-button button--validate" data-ng-class="'documentary-list__item-button--float-left':readOnly">
                <button
                    type="button"
                    class="button"
                    (click)="transmitDocument()"
                    [disabled]="disabletransmitDocButton(document)"
                    [ngClass]="{
                        'documentary-list__item-button--disabled': disabletransmitDocButton(document)
                    }"
                >
                    <em class="icon icon--arrow-up"></em>
                    <span class="button-text">{{ 'documentselection.documentlist.buttons.transmit' | i18n }}</span>
                </button>
            </div>
            <div *ngIf="!webCallBackMedical && document.idApi" data-ng-show="!readOnly &amp;&amp; !webcallbackAsked &amp;&amp; !appointmentMade" class="button--deny documentary-list__item-checkbox choice-box choice-box--inline-left">
                <input
                    id="checkbox_{{ document.typologie }}"
                    class="choice"
                    type="checkbox"
                    name="check_{{ document.typologie }}"
                    [(ngModel)]="checked"
                    (change)="onCheckboxChange()"
                    [disabled]="disabletransmitDocButton(document)"
                    [ngClass]="{
                        'documentary-list__item-checkbox--disabled': filesConforme(document) || filesProvided(document) || document.transmis
                    }"
                />
                <label class="choice-box__label acceptance-box__label" for="checkbox_{{ document.typologie }}">
                    <span data-ng-bind-html="i18n('documentselection.documentlist.document.checkbox.text1')">
                        {{ 'documentselection.documentlist.document.checkbox.text1' | i18n }}
                    </span>
                </label>
            </div>
        </ng-container>

        <em *ngIf="withAppointment" class="documentary-list__item-button documentary-list__item-button--byother button--deny">
            {{ 'documentselection.documentlist.doc.byother' | i18n }}
        </em>
    </div>

    <app-exam-details-modal-component *ngIf="showExamDetails" [exam]="examDetails" (hideModal)="toggleExamDetails()"> </app-exam-details-modal-component>
</div>
